import cn from 'classnames';
import { FC, useEffect } from 'react';
import { browserName, fullBrowserVersion, isMobile } from 'react-device-detect';
import { icons } from 'src/configs/icons';
import { getDeviceName } from 'src/helpers/utils';
import _style from './styles.module.scss';

type Props = {
  name: string | undefined;
  secretKey: string;
};

const SalesforceChat: FC<Props> = ({ name, secretKey }) => {
  useEffect(() => {
    // 1. Prevent multiple script injections
    if (document.getElementById('salesforce-chat-script')) return;

    // 2. Define global init function
    window.initEmbeddedMessaging = function () {
      try {
        window.embeddedservice_bootstrap.settings.language = 'pt_BR';
        window.embeddedservice_bootstrap.settings.hideChatButtonOnLoad = true;
        window.embeddedservice_bootstrap.init(
          '00Das00000AZezK',
          name,
          `https://conexaomarketing.my.site.com/${secretKey}`,
          {
            scrt2URL: 'https://conexaomarketing.my.salesforce-scrt.com',
          }
        );
      } catch (err) {
        console.error('Error loading Embedded Messaging:', err);
      }
    };

    // 3. Inject Salesforce script
    const script = document.createElement('script');
    script.id = 'salesforce-chat-script';
    script.type = 'text/javascript';
    script.src = `https://conexaomarketing.my.site.com/${secretKey}/assets/js/bootstrap.min.js`;
    script.onload = () => {
      if (window.initEmbeddedMessaging) {
        window.initEmbeddedMessaging();
      }
    };

    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    window.addEventListener('onEmbeddedMessagingWindowMinimized', () => {
      const iframe = window.embeddedservice_bootstrap.utilAPI.getEmbeddedMessagingFrame();
      if (iframe) {
        iframe.style.zIndex = -99;
      }
    });
  }, []);

  const openChat = (): void => {
    const iframe = window.embeddedservice_bootstrap.utilAPI?.getEmbeddedMessagingFrame();
    if (window.embeddedservice_bootstrap?.prechatAPI) {
      window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
        Browser_Name: `${browserName} ${fullBrowserVersion}`,
        Device_Name: getDeviceName(),
      });
    }
    window.embeddedservice_bootstrap.utilAPI?.launchChat().then(() => {
      if (iframe) {
        iframe.style.zIndex = 215;
      }
    });
  };

  return (
    <div className={_style.salesforce_chat_container}>
      {!isMobile && (
        <img src={icons.chat} onClick={openChat} className={cn(_style.chat_icon)} alt="salesforce-chat icon" />
      )}
    </div>
  );
};

export default SalesforceChat;
